import PageBackTitle from "../Component/PageBackTitle";
import React, { useState, useEffect, useRef, useCallback } from "react";
// import "./User.css";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import axios from "axios";
import "../Responsive/TableResponsive.css";
import { IoSearchOutline } from "react-icons/io5";
import { TbRefresh } from "react-icons/tb";
import Tooltip from "@mui/material/Tooltip";
import API_URL from "../../src/Config";
import Pagination from "../Component/Pagination";
import { MdExpandMore } from "react-icons/md";
import { HiOutlinePlus } from "react-icons/hi";
import { Link } from "react-router-dom";
import { MdOutlineModeEditOutline } from "react-icons/md";
import { FiEye } from "react-icons/fi";
import { parseMiApiError } from "./miIndexUtils";

function LocationList({ isSidebarExpanded }) {
  const [locationList, setLocationList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [searchInput, setSearchInput] = useState("");
  const [page, setPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(50);
  const [totalItems, setTotalItems] = useState(0);
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const popupRef = useRef(null);
  const containerRef = useRef(null);

  const showSnackbar = useCallback((message, severity = "success") => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  }, []);

  const fetchData = useCallback(async (currentPage, itemsPerPage) => {
    try {
      setLoading(true);
      const authKey = localStorage.getItem("authKey");

      const response = await axios.get(`${API_URL}/api/mi/locations`, {
        headers: {
          Authorization: authKey,
        },
        params: {
          page: currentPage,
          per_page: itemsPerPage,
          q: searchInput,
        },
      });

      setLocationList(response?.data?.locations || []);
      setTotalItems(response?.data?.total || 0);
    } catch (error) {
      console.error("Error fetching location data:", error.message);
      showSnackbar(parseMiApiError(error, "Error loading locations"), "error");
    } finally {
      setLoading(false);
    }
  }, [searchInput, showSnackbar]);

  useEffect(() => {
    fetchData(page, itemsPerPage);
  }, [fetchData, itemsPerPage, page]);

  const handlePaginationChange = (currentPage, itemsPerPage) => {
    setPage(currentPage);
    setItemsPerPage(itemsPerPage);
    localStorage.setItem("currentPage", currentPage);
    localStorage.setItem("itemsPerPage", itemsPerPage);
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  const handleSearchInputChange = (event) => {
    const value = event.target.value;
    setSearchInput(value);
  };

  const handleRefresh = () => {
    setSearchInput("");
    setPage(1);
    fetchData(1, itemsPerPage);
  };

  const handleSearch = () => {
    setPage(1);
    fetchData(1, itemsPerPage);
  };

  const handleButtonClick = (index, event) => {
    event.stopPropagation();
    setSelectedRowIndex(index === selectedRowIndex ? null : index);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setSelectedRowIndex(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <div
        className={`data-list-content-container page-content ${
          isSidebarExpanded ? "expanded" : "collapsed"
        }`}
      >
        <div className="data-list-content" ref={containerRef}>
          <div className="data-list-header">
            <div className="data-list-header-content">
              <PageBackTitle>All Locations</PageBackTitle>
              <div className="data-list-heading-content-right-side">
                <div className="search-bar-container">
                  <input
                    type="text"
                    placeholder="Search..."
                    value={searchInput}
                    onChange={handleSearchInputChange}
                    onKeyPress={(e) => e.key === "Enter" && handleSearch()}
                    className="search-bar"
                  />
                  <IoSearchOutline
                    className="search-bar-icon"
                    onClick={handleSearch}
                    style={{ cursor: "pointer" }}
                  />
                </div>

                <Link to="/mi-add-location" className="data-list-new">
                  <Tooltip title="New Location" arrow>
                    <button className="new-button">
                      <HiOutlinePlus className="new-plus-icon" /> New
                    </button>
                  </Tooltip>
                </Link>

                <Tooltip title="Refresh List" arrow>
                  <button className="refresh-button" onClick={handleRefresh}>
                    <TbRefresh className="refresh-icon" />
                  </button>
                </Tooltip>
              </div>
            </div>
          </div>

          <div className="header-separator"></div>
          <div className="data-list-body">
            <div className="data-list-scroll-body">
              <div className="data-list-table">
                {loading ? (
                  <div className="loader-container">
                    <div className="loader"></div>
                    <div>Loading...</div>
                  </div>
                ) : locationList?.length > 0 ? (
                  <table className="table multilevel-data">
                    <thead>
                      <tr>
                        <th>LOCATION NAME</th>
                        <th>LOCATION TYPE</th>
                        <th>REGION</th>
                        <th>STATE OFFICE</th>
                        <th>ZONE</th>
                        <th>TANKAGE CAPACITY</th>
                        <th className="">ACTION</th>
                      </tr>
                    </thead>
                    <tbody className="data-list-scroll-bodys">
                      {locationList.map((location, index) => (
                        <tr key={location.location_id} className="hoverable-row">
                          <td>{location.location_name || "NA"}</td>
                          <td>{location.location_type || "NA"}</td>
                          <td>{location.region || "NA"}</td>
                          <td>{location.state_office || "NA"}</td>
                          <td>{location.zone || "NA"}</td>
                          <td>{location.tankage_capacity || "NA"}</td>

                          <td className="-pop">
                            <div className="">
                              <button
                                className="edit-data-button"
                                onClick={(event) =>
                                  handleButtonClick(index, event)
                                }
                              >
                                <div className="edit-button">
                                  <MdExpandMore />
                                </div>
                              </button>
                            </div>
                          </td>
                          {selectedRowIndex === index && (
                            <div
                              className="edit-popup"
                              style={{
                                position: "absolute",
                                top: "60.5%",
                                right: "7%",
                              }}
                              ref={popupRef}
                            >
                              <div className="edit-popup-contant">
                                <div className="edit-popup-button">
                                  <Link
                                    to={`/mi-location-view/${location.location_id}`}
                                    className="inquiry-new"
                                  >
                                    <button className="edit-button-inquiry">
                                      <FiEye /> View
                                    </button>
                                  </Link>
                                </div>
                                <div className="edit-popup-button">
                                  <Link
                                    to={`/mi-edit-location/${location.location_id}`}
                                    className="inquiry-new"
                                  >
                                    <button className="edit-button-inquiry">
                                      <MdOutlineModeEditOutline /> Edit
                                    </button>
                                  </Link>
                                </div>
                              </div>
                            </div>
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <div className="no-users-container">
                    <div className="no-users-message">
                      No Locations Found
                    </div>
                  </div>
                )}
              </div>
              <Pagination
                showPerPage={itemsPerPage}
                total={totalItems}
                onPaginationChange={handlePaginationChange}
              />
            </div>
          </div>
        </div>
      </div>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        style={{ marginTop: "35px", marginLeft: "20px" }}
      >
        <MuiAlert onClose={handleSnackbarClose} severity={snackbarSeverity}>
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
}

export default LocationList;
